import { render, staticRenderFns } from "./payBox.vue?vue&type=template&id=9514b7c8&"
import script from "./payBox.vue?vue&type=script&lang=js&"
export * from "./payBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports